import { render, staticRenderFns } from "./TwoFactorAuthenticationBackupCode.vue?vue&type=template&id=73b132a3&scoped=true&"
import script from "./TwoFactorAuthenticationBackupCode.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationBackupCode.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthenticationBackupCode.vue?vue&type=style&index=0&id=73b132a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b132a3",
  null
  
)

export default component.exports